module.exports = __webpack_public_path__ + "entry-logged-out-0d45d450/salary-background-mobile-cb6d499f45b918e2ceadaae16fa3f513.svg";